<template>
    <Modal
        v-model="_value"
        width="650"
        title="快速生成安装证明"
        @on-visible-change="visibleChange"
        ok-text="关闭"
        cancel-text=""
      >
      <Form autoComplete="on" class="card-box login-form" :label-width="140">
        <Form-item label="地区">
          <Select style="width: 60px;width: 169px;" v-model="reqParams.certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Row>
          <Col span="12">
        <Form-item label="车主名称">
          <Input placeholder="车主名称" v-model="reqParams.vehicleOwnerName"></Input>
        </Form-item>
          </Col>
          <Col span="12">
        <Form-item label="车牌号码">
          <Input placeholder="车牌号码" v-model="reqParams.registrationNum"></Input>
        </Form-item>
          </Col>
        </Row>
        <Row>
          <Col span="12">
        <Form-item label="车辆识别码">
          <Input placeholder="车辆识别码" v-model="reqParams.identificationCode"></Input>
        </Form-item>
          </Col>
          <Col span="12">
        <Form-item label="车牌颜色">
          <Input placeholder="车牌颜色" v-model="reqParams.registrationColor"></Input>
        </Form-item>
          </Col>
        </Row>
            <Row>
              <Col span="12">
        <Form-item label="发动机号">
          <Input placeholder="发动机号" v-model="reqParams.engineNum"></Input>
        </Form-item>
              </Col>
              <Col span="12">
        <Form-item label="车架号">
          <Input placeholder="车架号" v-model="reqParams.vin"></Input>
        </Form-item>
              </Col>
            </Row>
                <Row>
                  <Col span="12">
        <Form-item label="主机号">
          <Input placeholder="主机号" v-model="reqParams.terminalNum"></Input>
        </Form-item>
                  </Col>
                  <Col span="12">
        <Form-item label="终端型号">
<!--          <Input placeholder="主机号" v-model="reqParams.positioningdevicemodel"></Input>-->
          <Select placeholder="终端型号" style="width: 169px"
                  v-model="reqParams.positioningdevicemodel"
          >
            <Option v-for="(option, index) in positioningDeviceModelOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
          </Select>
        </Form-item>
                  </Col>
                </Row>
                    <Row>
                      <Col span="12">
        <Form-item label="服务到费期">
          <DatePicker type="date" placeholder="安装日期" style="width: 169px;margin-right: 10px;"
                      v-model="reqParams.serviceDatetime"></DatePicker>
        </Form-item>
                      </Col>
                      <Col span="12">
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 169px;margin-right: 10px;"
                      v-model="reqParams.setupDatetime"></DatePicker>
        </Form-item>
                      </Col>
                    </Row>
                        <Row>
                          <Col span="12">
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 169px;margin-right: 10px;"
                      v-model="reqParams.printDatetime"></DatePicker>
        </Form-item>
                          </Col>
                        </Row>
        <Form-item label="">
          <Button @click="onClear" style="margin-right: 5px;">清空参数</Button>
          <Button @click="onExport" style="margin-right: 5px;">生成证明</Button>
          <Button @click="onVideoExport">生成视频机证明</Button>
        </Form-item>
      </Form>
    </Modal>
</template>
<script>


  import Vue from 'vue';
  import axios from '@/libs/api.request'
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'quicklygeneratecertificate',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {

        certificateAreaOptions: [
          {label: '中山', value: 1},
          {label: '江门', value: 2},
        ],

        reqParams:{
          vehicleOwnerName:null,
          registrationNum:null,
          identificationCode:null,
          registrationColor:'黄色',
          engineNum:null,
          vin:null,
          terminalNum:null,
          positioningdevicemodel:null,
          certificateArea:1,
          setupDatetime:null,
          printDatetime:null,
          serviceDatetime:null
        },

        positioningDeviceModelOptions: [],
      }
    },
    methods: {
      ...mapActions([
        'PositioningDeviceInfoServ_QuicklyGenerateCertificate'
      ]),
      onClear(){
        this.reqParams.vehicleOwnerName = null
        this.reqParams.registrationNum = null
        this.reqParams.identificationCode = null
        this.reqParams.registrationColor = '黄色'
        this.reqParams.engineNum = null
        this.reqParams.vin = null
        this.reqParams.terminalNum = null
        this.reqParams.positioningdevicemodel = null
        this.reqParams.certificateArea = 1
        this.reqParams.setupDatetime = null
        this.reqParams.printDatetime = null
        this.reqParams.serviceDatetime = null
      },
      onExport() {
        this.reqParams.setupDatetime = new Date(this.reqParams.setupDatetime).getTime()
        this.reqParams.printDatetime = new Date(this.reqParams.printDatetime).getTime()
        this.reqParams.serviceDatetime = new Date(this.reqParams.serviceDatetime).getTime()
        // store.dispatch('PositioningDeviceInfoServ_QuicklyGenerateCertificate', {
        //   params: this.reqParams,
        //   urlparams: null
        // }).then(() => {
        //
        // }).catch(err => {
        //   this.$Message.error(err)
        // });

        axios.request({
          method: 'POST',
          // url: '/im/positioningdeviceinfo/quicklygeneratecertificate',
          url: '/im/positioningdeviceinfo/quicklygeneratecertificateforyiliu',
          data: this.reqParams,
          responseType: 'blob'
        }).then(res => {
          let blob = res.data
          let reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = (e) => {
            let a = document.createElement('a')

            let name = ''
            if(this.reqParams.registrationNum){
              name = this.reqParams.registrationNum + '_' + this.reqParams.registrationColor
            }else{
              name = this.reqParams.vin
            }

            a.download = name + '.doc'
            a.href = e.target.result
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
        }).catch((error) => {

        })

        // axios.request('/im/positioningdeviceinfo/quicklygeneratecertificate', this.reqParams, {
        //   responseType: 'blob'
        // }).then(res => {
        //     let blob = res.data
        //     let reader = new FileReader()
        //     reader.readAsDataURL(blob)
        //     reader.onload = (e) => {
        //       let a = document.createElement('a')
        //       a.download = 'fileName'
        //       a.href = e.target.result
        //       document.body.appendChild(a)
        //       a.click()
        //       document.body.removeChild(a)
        //     }
        // })
      },
      onVideoExport(){
        this.reqParams.setupDatetime = new Date(this.reqParams.setupDatetime).getTime()
        this.reqParams.printDatetime = new Date(this.reqParams.printDatetime).getTime()
        this.reqParams.serviceDatetime = new Date(this.reqParams.serviceDatetime).getTime()
        axios.request({
          method: 'POST',
          // url: '/im/positioningdeviceinfo/quicklygeneratevideocertificate',
          url: '/im/positioningdeviceinfo/quicklygeneratevideocertificateforyiliu',
          data: this.reqParams,
          responseType: 'blob'
        }).then(res => {
          let blob = res.data
          let reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = (e) => {
            let a = document.createElement('a')

            let name = ''
            if(this.reqParams.registrationNum){
              name = '视频机'+ '_' + this.reqParams.registrationNum + '_' + this.reqParams.registrationColor
            }else{
              name = this.reqParams.vin
            }

            a.download = name + '.doc'
            a.href = e.target.result
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
        }).catch((error) => {

        })
      },
      visibleChange(val) {
        if (val) {

        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        store.dispatch('PositioningDeviceTypeServ_GetAll',{

        }).then(res=>{
          if (store.getters.get_PositioningDeviceType_GetAllResult) {
            store.getters.get_PositioningDeviceType_GetAllResult.forEach(item=>{
              this.positioningDeviceModelOptions.push( { label: item.name, value: item.id },)
            })
          }
        }).catch(err=>{
          console.log(err)
          this.$Message.error(err)
        })
      })
    }
  }
</script>
